import { IconName } from '@fortawesome/pro-solid-svg-icons'
import React, { Component } from 'react'
import {
  Image,
  ImageSourcePropType,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'
import { colors } from 'src/assets/colors'
import { FontAwesomeIconWrapper } from 'src/components/FontAwesomeIcon'
import { st } from 'src/locales'
import { IconCircle } from '../IconCircle'

const styles = StyleSheet.create({
  imageContainer: {
    width: 15,
    height: 15,
    paddingBottom: 4,
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
  },
  title: {
    fontSize: 13,
    color: colors.textDark,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontWeight: '600',
  },
  textContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainer: {
    marginBottom: 5,
  },
})

export enum CardIconActionStyle {
  Circle = 'circle',
  Regular = 'regular',
}

interface IProps {
  image?: ImageSourcePropType
  icon?: IconName
  iconColor?: string
  iconStyle?: CardIconActionStyle
  title: string
  titleColor?: string
  containerStyle?: StyleProp<ViewStyle>
  subtitle?: string
  onPress: () => void
  testID?: string
  isDisabled?: boolean
  titleMaxLines?: number
}

export class HomeFavIconAction extends Component<IProps> {
  public render() {
    return (
      <TouchableOpacity
        testID={this.props.testID}
        style={[styles.buttonContainer, this.props.containerStyle]}
        onPress={() => this.props.onPress()}
        disabled={this.props.isDisabled}
        accessibilityRole='button'
        accessibilityHint={st.components.homeFavIconAction.accessibilityHint()}
      >
        <View style={styles.buttonContainer}>
          {this.renderIconOrImage()}
          <View style={styles.textContainer}>
            <Text
              style={[styles.title, this.props.titleColor ? { color: this.props.titleColor } : null]}
              numberOfLines={this.props.titleMaxLines || 2}
            >
              {this.props.title}
            </Text>
            {this.props.subtitle ? <Text style={styles.title}> {this.props.subtitle} </Text> : null}
          </View>
        </View>
      </TouchableOpacity>
    )
  }

  private renderIconOrImage() {
    if (this.props.image) {
      return <Image resizeMode='contain' style={styles.imageContainer} source={this.props.image} />
    } else if (this.props.icon && this.props.iconStyle === CardIconActionStyle.Regular) {
      return <FontAwesomeIconWrapper icon={this.props.icon} color={this.props.iconColor || colors.textDark} size={14} />
    } else if (this.props.icon && this.props.iconColor) {
      return <IconCircle style={styles.iconContainer} icon={this.props.icon} backgroundColor={this.props.iconColor} />
    }
    throw new Error('No Image or Icon provided!')
  }
}
